import message from "./message";
import messageBox from "./messageBox";
const $msg = message
const $box = messageBox
export { $msg, $box }